const types = {
  ADD_IDENTITY_PHOTO_FILE: "ADD_IDENTITY_PHOTO_FILE",
  REMOVE_IDENTITY_PHOTO_FILE: "REMOVE_IDENTITY_PHOTO_FILE",
  SET_IDENTIFICATION_TYPE: "SET_IDENTIFICATION_TYPE",
  SET_GENDER: "SET_GENDER",
  SET_REGISTRATION_DATA: "SET_REGISTRATION_DATA",
  SET_CLIENT_PHOTO_FILE: "SET_CLIENT_PHOTO_FILE",
  REMOVE_CLIENT_PHOTO_FILE: "REMOVE_CLIENT_PHOTO_FILE",
  SET_SELECTED_STATE: "SET_SELECTED_STATE",
  SET_SELECTED_CITY: "SET_SELECTED_CITY",
  SET_ADITIONAL_DATA: "SET_ADITIONAL_DATA",
  SET_SIMULATION_DATA: "SET_SIMULATION_DATA",
  SET_CREDIT_ID: "SET_CREDIT_ID",
  SET_CREDIT: "SET_CREDIT",
  SET_EXISTING_CLIENT_DATA: "SET_EXISTING_CLIENT_DATA",
  SET_SOLICITATION_DATA: "SET_SOLICITATION_DATA",
  SET_SELECTED_BIRTH_CITY: "SET_SELECTED_BIRTH_CITY",
};

export default types;
